import { trackError } from '@billy/track-error'
import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { TargetType } from '../../../enums/eInvoicing'
import { QueryKeys } from '../../../enums/queryKeys'
import { Scope } from '../../../enums/scope'
import { isAuthorized } from '../../../utils/isAuthorized'
import { PDP_NETWORK_TYPE } from '../constants'
import { getEInvoicingKYCStatus } from '../query-api'

interface UseGetEInvoicingKYCStatusOptions {
  enabled?: boolean
  onError?: () => void
}

export const useGetEInvoicingKYCStatus = ({ enabled = true, onError }: UseGetEInvoicingKYCStatusOptions = {}) => {
  const { organization } = useUserOrganization()

  const targetType = TargetType.BILLY
  const hasOrganizationReadScope = isAuthorized(Scope.OrganizationRead)

  const { data, isLoading } = useQuery(
    [QueryKeys.EInvoicingGetKYCStatus, PDP_NETWORK_TYPE, organization?.id],
    () => {
      if (!organization?.id) {
        trackError('Organization ID is required to get KYC status')
        return Promise.resolve({ data: null })
      }
      return getEInvoicingKYCStatus({
        network: PDP_NETWORK_TYPE,
        targetId: organization.id,
        targetType,
      })
    },
    {
      enabled: enabled && !!organization?.id && hasOrganizationReadScope,
      onError,
    },
  )

  return {
    data: data?.data,
    isProcessing: isLoading,
  }
}
